module.exports = __webpack_public_path__ + "static/media/ECOLE.89756627.png";